import API from '@/api';
import moment from 'moment';
import * as types from '@/store/mutationTypes';
import _ from 'lodash';
import Vue from 'vue';

const state = {
  companyId: null,
  list: [],
  loadingLoads: false,
  timestamp: null,
};

const getters = {
  list: qbState => qbState.list,
  companyId: qbState => qbState.companyId,
  timestamp: qbState => qbState.timestamp,
  loadingLoads: qbState => qbState.loadingLoads,
};

const mutations = {
  [types.START_LOADING](loadState) {
    loadState.loadingLoads = true; // eslint-disable-line no-param-reassign
  },
  [types.SET_DISPATCH_REQUESTS](loadState, { loads, companyId, loading }) {
    loadState.list = loads; // eslint-disable-line no-param-reassign
    loadState.companyId = companyId;// eslint-disable-line no-param-reassign
    loadState.loadingLoads = loading; // eslint-disable-line no-param-reassign
    loadState.timestamp = moment(); // eslint-disable-line no-param-reassign
  },
  [types.UPDATE_DISPATCH_REQUEST](loadState, loadData) {
    const loadIndex = _.findIndex(loadState.list,
      load => load.humanId === loadData.humanId);
    Vue.set(loadState.list, loadIndex, loadData);
  },
};

const actions = {
  async getDispatchedRequests({ commit, dispatch }, companyId) {
    try {
      commit(types.START_LOADING);
      const response = await API.dispatchers.getDashboardV2({ companyId });
      commit(types.SET_DISPATCH_REQUESTS, { loads: response.data.items, companyId, loading: false });
    } catch (error) {
      dispatch('applications/setErrorNotification', {
        message: error.message,
      }, { root: true });
    }
  },
  updateLoad({ commit }, loadData) {
    commit(types.UPDATE_DISPATCH_REQUEST, loadData);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/dispatchRequests.js